import React from "react";
import OutsideOrgSingleQuoteContent from "../components/quotes/outside-org-single-quote-content";

const OutsideOrgSingleQuote = () => {
  return <OutsideOrgSingleQuoteContent />;
};

export default OutsideOrgSingleQuote;
